export default {
    planList (state, {plans}) {
        state.plans = plans
    },
    SetDefaultPlan (state, {defaultPlan}) {
        state.defaultPlan = defaultPlan
    }
}



// WEBPACK FOOTER //
// ./src/store/plans/mutations.js